import React from 'react';
import CompMarquee from '../Components/CompMarquee';
import CompContentBlock from '../Components/CompContentBlock';
import './StartupsAndProducts.css'; // Import the CSS file
import Chip from '@mui/material/Chip';
import { Grid } from '@mui/material';
import CompContactWidget from '../Components/CompContactWidget';
import UXImgStartupsAndProductsFeature1 from '../Assets/Images/uxi-2025-startupsandproducts-feature1.png';
import UXImgStartupsAndProductsFluxity from '../Assets/Images/uxi-products-fluxity.png';
import UXImgStartupsAndProductsStealth from '../Assets/Images/uxi-products-stealth.png';


function StartupsAndProducts() {
  return (
    <div className="startups-and-products-container">
      <CompMarquee title="Innovations Every Day" subTitle="Here's what we're building now." />
      <div>
      <CompContentBlock heading="Targeted Innovation, User First" subheading="Products that make an impact.">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <img src={UXImgStartupsAndProductsFeature1} alt="Our Mission" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={12} md={8}>
            <h4>Products Designed for Industry Needs</h4>
            <p>
              All of the products designed by UX Integrity either in whole or collaboratively are meant to be sustainable and innovative solutions to fit strategic industry gaps.  We are taking key challenges and turning them into business value for our users.
            </p>
            </Grid>
            </Grid>
      </CompContentBlock>
      </div>
      <div>
      <CompContentBlock heading="Product Roadmap" subheading="In the works right now.">
      <Grid container spacing={2}>
        <Grid item xs={3} md={1}>
              <img src={UXImgStartupsAndProductsFluxity} alt="Product Logo" style={{ width: '100%' }} />
              </Grid>
              <Grid item xs={9} md={11}>
                <h4>Fluxity</h4>
                <Chip label="Co-Founders" style={{ backgroundColor: 'rgba(255, 165, 0, 0.5)', color: 'white', width: 'fit-content', marginTop: '8px' }} /> 
                <p>Fluxity is a one-stop-shop UX management platform designed for small to enterprise teams to stay truly center-out in their approach to user-centric products.</p>
                
                </Grid>
                </Grid>

        <Grid container spacing={2}>
                <Grid item xs={3} md={1}>
              <img src={UXImgStartupsAndProductsStealth} alt="Product Logo" style={{ width: '100%', border: '1px solid #ffffff' }} />
              </Grid>
              <Grid item xs={9} md={11}>
                <h4>Facility Visibility</h4>
                <Chip label="Owned / Incubating" style={{ backgroundColor: 'rgba(255, 165, 0, 0.5)', color: 'white', width: 'fit-content', marginTop: '8px'  }} /> 
                <p>Facility Visibility is a facility management platform that allows for real-time tracking of assets, resources and people in a facility for logistics and security foundations.</p>
                </Grid>
                </Grid>
      </CompContentBlock>
      <CompContactWidget />
      </div>
    </div>
  );
}

export default StartupsAndProducts;
